import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow, FlexColumn, Gap } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { AddressBlacklistCard } from './cards/address-blacklist-card';
// import { HighValueThresholdCard } from './cards/high-value-threshold-card';
import { InternationalAddressMismatchCard } from './cards/international-address-mismatch-card';
// import { KnownAddressCard } from './cards/known-address-card';
// import { RushShippingCard } from './cards/rush-shipping-card';
import { SystemCard } from './cards/system-card';
import { UnusualOrderTimeCard } from './cards/unusual-order-time-card';
// import { VelocityAlertsCard } from './cards/velocity-alerts-card';
import { SETTING_PATHS, FUZZY_THRESHOLD } from './constants';
import { useLossPreventionState } from './hooks/use-loss-prevention-state';
import { messages } from './messages';
import styles from './styles.module.less';

export const FeatureManagement = () => {
  const { settings, isLoading, isSaving, updateSetting, saveSettings } = useLossPreventionState();

  const fuzzyFlagThreshold = settings?.addressBlacklist?.fuzzyFlagThreshold ?? 0;
  const fuzzyBlockThreshold = settings?.addressBlacklist?.fuzzyBlockThreshold ?? 0;
  const hasValidationErrors =
    settings?.addressBlacklist?.enableFuzzyMatching && fuzzyBlockThreshold - fuzzyFlagThreshold < FUZZY_THRESHOLD.MIN_GAP;

  // const handleReprocess = useCallback(() => {
  //   // TODO: Open reprocess modal
  // }, []);

  return (
    <div className={styles['feature-management-content']}>
      <div className={styles['page-header']}>
        <Text className={styles['page-title']} textType={TextType.H2} value={messages.pageTitle} />
        <Text className={styles['page-description']} textType={TextType.Description} value={messages.pageDescription} />
      </div>
      {isLoading || !settings ? (
        <LoadingIndicator />
      ) : (
        <>
          {/* Cards Section */}
          <FlexColumn className={styles['cards-section']} gap={Gap.Space16}>
            <SystemCard
              isLossPreventionEnabled={settings.isEnabled}
              onToggle={(enabled) => updateSetting(SETTING_PATHS.isEnabled, enabled)}
            />
            <FlexColumn className={!settings.isEnabled ? styles['system-disabled'] : undefined} gap={Gap.Space16}>
              {/* <KnownAddressCard
                isCardDisabled={!settings.knownAddress.enabled}
                onToggle={(enabled) => updateSetting(SETTING_PATHS.knownAddress.enabled, enabled)}
              /> */}
              {/* <RushShippingCard
                isCardDisabled={!settings.rushShipping.enabled}
                onToggle={(enabled) => updateSetting(SETTING_PATHS.rushShipping.enabled, enabled)}
              /> */}
              {/* <HighValueThresholdCard
                isCardDisabled={!settings.highValueThreshold.enabled}
                maxPreviousOrders={settings.highValueThreshold.maxPreviousOrders}
                onFeatureToggle={(enabled) => updateSetting(SETTING_PATHS.highValueThreshold.enabled, enabled)}
                onSettingChange={(field, value) => updateSetting(SETTING_PATHS.highValueThreshold[field], value)}
                orderValueThresholdUsd={settings.highValueThreshold.orderValueThresholdUsd}
              /> */}
              {/* <VelocityAlertsCard
                isCardDisabled={!settings.velocityAlerts.enabled}
                maxOrdersPerAddress={settings.velocityAlerts.maxOrdersPerAddress}
                onFeatureToggle={(enabled) => updateSetting(SETTING_PATHS.velocityAlerts.enabled, enabled)}
                onSettingChange={(field, value) => updateSetting(SETTING_PATHS.velocityAlerts[field], value)}
                timeWindowHours={settings.velocityAlerts.timeWindowHours}
              /> */}
              <AddressBlacklistCard
                enableFuzzyMatching={settings.addressBlacklist.enableFuzzyMatching}
                fuzzyBlockThreshold={settings.addressBlacklist.fuzzyBlockThreshold}
                fuzzyFlagThreshold={settings.addressBlacklist.fuzzyFlagThreshold}
                isCardDisabled={!settings.addressBlacklist.enabled}
                onFeatureToggle={(enabled) => updateSetting(SETTING_PATHS.addressBlacklist.enabled, enabled)}
                onSettingChange={(field, value) => updateSetting(SETTING_PATHS.addressBlacklist[field], value)}
              />
              <InternationalAddressMismatchCard
                isCardDisabled={!settings.internationalAddressMismatch.enabled}
                onToggle={(enabled) => updateSetting(SETTING_PATHS.internationalAddressMismatch.enabled, enabled)}
              />
              <UnusualOrderTimeCard
                endHour={settings.unusualOrderTime.endHour}
                isCardDisabled={!settings.unusualOrderTime.enabled}
                onFeatureToggle={(enabled) => updateSetting(SETTING_PATHS.unusualOrderTime.enabled, enabled)}
                onSettingChange={(field, value) => updateSetting(SETTING_PATHS.unusualOrderTime[field], value)}
                startHour={settings.unusualOrderTime.startHour}
              />
            </FlexColumn>
          </FlexColumn>

          <FlexRow className={styles['reprocess-section']}>
            {/* TODO: Uncomment when reprocess endpoint is implemented
            <Button disabled={isSaving} onClick={handleReprocess} theme={THEME_CONSTANTS.secondary}>
              <FormattedMessage {...messages.reprocessButton} />
            </Button>
            */}
            <FlexRow className={styles.actions}>
              <Button
                disabled={isSaving || hasValidationErrors}
                isLoading={isSaving}
                onClick={saveSettings}
                theme={THEME_CONSTANTS.primary}
              >
                <FormattedMessage {...messages.saveButton} />
              </Button>
            </FlexRow>
          </FlexRow>
        </>
      )}
    </div>
  );
};
